// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { format } from 'date-fns';

const api = new APICore();

const BASE_URL = config.TRACKING_REPORTS_URL;
const ORDERS_BASE_URL = config.ORDERS_URL;

function getDelayedFacilities(query) {
    const endpoint = '/delayed_facilities';
    return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
}

function getDelayedFacilitiesReport(query) {
    const endpoint = '/delayed_facilities_report';
    return api.getFile(`${BASE_URL}${endpoint}?${query}`);
}

function getShipmentTrackingRecords(query): any {
    const endpoint = '/shipment_tracking_records';
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildShipmentTrackingRecordsQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
}

function getShipmentTrackingReport(query): any {
    const endpoint = '/shipment_tracking_records_report';
    if (typeof query === 'string') {
        return api.getFile(`${BASE_URL}${endpoint}?${query}`);
    }
    const queryParams = buildShipmentTrackingRecordsQueryParams(query);
    return api.getFile(`${BASE_URL}${endpoint}`, queryParams);
}

function getAggregatedDelayedShipments(query) {
    const endpoint = '/aggregated_delayed_shipments';
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildShipmentTrackingRecordsQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
}

function getAggregatedDelayedShipmentsReport(query) {
    const endpoint = '/aggregated_delayed_shipments_report';
    if (typeof query === 'string') {
        return api.getFile(`${BASE_URL}${endpoint}?${query}`);
    }
    const queryParams = buildShipmentTrackingRecordsQueryParams(query);
    return api.getFile(`${BASE_URL}${endpoint}`, queryParams);
}

function getAddressReport(query) {
    const endpoint = '/address_reports';
    if (typeof query === 'string') {
        return api.get(`${ORDERS_BASE_URL}${endpoint}?${query}`, {}, {});
    }
    return api.get(`${ORDERS_BASE_URL}${endpoint}`, query || {}, {});
}

function getAddressReportFile(query) {
    const endpoint = '/address_reports/report';
    if (typeof query === 'string') {
        return api.getFile(`${ORDERS_BASE_URL}${endpoint}?${query}`);
    }
    return api.getFile(`${ORDERS_BASE_URL}${endpoint}`, query || {});
}

export const buildShipmentTrackingRecordsQueryParams = (query) => {
    const result = {
    };
    if (query.get('tracking_status') !== 'all') {
        result.tracking_status = query.get('tracking_status');
    }
    const integrationId = query.get('integration_id');
    if (integrationId) {
        if (integrationId.toLowerCase() === 'commerceship') {
            result.cs = true;
        } else {
            result.cs = false;
            result.integration_id = integrationId;
        }
    }
    if (query.has('warehouse_id')) {
        result.warehouseIds = query.getAll('warehouse_id');
    }
    if (query.has('ship_date_from')) {
        result.ship_date_from = format(new Date(query.get('ship_date_from')), 'YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('ship_date_to')) {
        result.ship_date_to = format(new Date(query.get('ship_date_to')), 'YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('estimated_delivery_start_date')) {
        result.estimated_delivery_start_date = format(new Date(query.get('estimated_delivery_start_date')), 'YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('estimated_delivery_end_date')) {
        result.estimated_delivery_end_date = format(new Date(query.get('estimated_delivery_end_date')), 'YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('actual_delivery_start_date')) {
        result.actual_delivery_start_date = format(new Date(query.get('actual_delivery_start_date')), 'YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('actual_delivery_end_date')) {
        result.actual_delivery_end_date = format(new Date(query.get('actual_delivery_end_date')), 'YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('delivery_status')) {
        result.delivery_status = query.getAll('delivery_status');
    }
    if (query.has('tracking_numbers')) {
        result.tracking_numbers = query.getAll('tracking_numbers');
    }
    if (query.has('tracking_status')) {
        result.tracking_status = query.getAll('tracking_status');
    }
    if (query.has('package_type')) {
        result.package_type = query.getAll('package_type');
    }
    if (query.has('carriers')) {
        result.carriers = query.getAll('carriers');
    }
    if (query.has('service_level_groups')) {
        result.service_level_groups = query.getAll('service_level_groups');
    }
    if (query.has('domestic')) {
        result.domestic = query.get('domestic');
    }
    if (query.has('ground')) {
        result.ground = query.get('ground');
    }
    if (query.has('external_order_number')) {
        result.external_order_number = query.getAll('external_order_number');
    }
    if (query.has('from_address_postal_code')) {
        result.from_address_postal_code = query.getAll('from_address_postal_code');
    }
    if (query.has('from_address_state_province')) {
        result.from_address_state_province = query.getAll('from_address_state_province');
    }
    if (query.has('to_address_postal_code')) {
        result.to_address_postal_code = query.getAll('to_address_postal_code');
    }
    if (query.has('to_address_state_province')) {
        result.to_address_state_province = query.getAll('to_address_state_province');
    }
    if (query.has('events_city')) {
        result.events_city = query.getAll('events_city');
    }
    if (query.has('events_state')) {
        result.events_state = query.getAll('events_state');
    }
    if (query.has('events_postal_code')) {
        result.events_postal_code = query.getAll('events_postal_code');
    }
    return result;
};

export {
    getDelayedFacilities,
    getDelayedFacilitiesReport,
    getShipmentTrackingRecords,
    getShipmentTrackingReport,
    getAggregatedDelayedShipments,
    getAggregatedDelayedShipmentsReport,
    getAddressReport,
    getAddressReportFile,
};
